<script setup lang="ts">
  import Badge from '@/common/ui/components/Badge.vue';
  import type {Status} from '@/console';
  import {computed} from 'vue';
  import {ProjectStatus} from '@/types/ProjectStatus';

  const props = withDefaults(
    defineProps<{
      status?: Status;
    }>(),
    {
      status: () => ({
        handle: 'trialing',
        name: 'Trialing',
      }),
    }
  );

  const type = computed(() => {
    if (props.status.handle === ProjectStatus.Active) {
      return 'success';
    }

    if (
      props.status.handle === ProjectStatus.Canceled ||
      props.status.handle === ProjectStatus.Disabled
    ) {
      return 'default';
    }

    if (props.status.handle === ProjectStatus.Unpaid) {
      return 'warning';
    }

    if (props.status.handle === ProjectStatus.PastDue) {
      return 'danger';
    }

    if (props.status.handle === ProjectStatus.Trialing) {
      return 'info';
    }

    return 'default';
  });
</script>

<template>
  <Badge :type="type" v-bind="$props">{{ status.name }}</Badge>
</template>

<style scoped></style>
